//#region Libraries
import { 
    useState, useEffect } from "react";
//#endregion
//#region Styles
import {
    Column, 
    SubtitleSection 
} from "components/styles";
//#endregion
//#region Components
import HandlerRadio from "components/CustomRadio/CustomRadio";
import HandlerCheckbox, { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
//#endregion

const StudentsSection = ({
    form, 
    changeField, 
    allCampus = [],
    modalities,
    errors,
    isAsesoria=false,
    formCampus={},
    changeFieldBatch
}) => {
    const visibleCampus = allCampus;

    //#region State
    const [selectAllCampus, setAllCampus] = useState(false);
    //#endregion
    //#region Effects

    // useEffect(() => {
    //     if(isAsesoria){
    //         changeModalityId(3)
    //     }
    // }, [])

    useEffect(() => {        
        if(!isAsesoria) return;
        changeFieldBatch(
            {
                publicByCampusIds: visibleCampus.map(row => row.id),
                modalityId: 3
            }
        );
    }, [isAsesoria, formCampus.place, visibleCampus, changeFieldBatch])
    
    const initCheckerPublicByCampusIds = () => {
        if (form.publicByCampusIds.length > 0 && form.publicByCampusIds.length === visibleCampus.length) {
            setAllCampus(true);
            return;
        }
        setAllCampus(false);
    };
    useEffect(initCheckerPublicByCampusIds, [form.publicByCampusIds, visibleCampus.length]);
    
    //#endregion
    //#region Functions
    const changePublicByCampusField = value => {
        const { publicByCampusIds } = form;
        const newPublicByCampusInFormField = (
            !isPublicByCampusInFormField(value) 
            ? [...publicByCampusIds, value] 
            : publicByCampusIds.filter(id => value !== id)
        );
        changeField(
            "publicByCampusIds", 
            newPublicByCampusInFormField, false);
    }
    const changeModalityId = modalityId => {
        changeField("modalityId", modalityId, false);
    }
    const isPublicByCampusInFormField = value => {
        return form.publicByCampusIds.some(currentId => currentId === value);
    }
    const changeAllCampus = () => {
        const newValue = isAsesoria
            ? visibleCampus.map(row => row.id)
            : (selectAllCampus ? [] : visibleCampus.map(row => row.id));

            if(isAsesoria){
                changeFieldBatch(
                    {
                        publicByCampusIds: newValue,
                        modalityId: 3
                    }
                )
                return;
            };
        changeField(
            "publicByCampusIds",
            newValue,
            false);
    }

    //#endregion
    const { modalityId } = form;
    return (
        <>
            <Column marginBottom="20px" align="flex-start">
                <SubtitleSection>Dirigido a estudiantes del campus:</SubtitleSection>
                <HandlerCheckbox
                    checkboxProps={
                        visibleCampus.map(({
                            id, name: _name
                        }) => ({
                            value: id, 
                            label: _name,
                            checked: isPublicByCampusInFormField(id)
                        }))
                    }
                    onChange={id => changePublicByCampusField(id)}
                    error={errors.publicByCampusIds}/>
                <CustomCheckbox
                    label="Todos los campus" 
                    variant="switch"
                    checked={selectAllCampus}
                    onChange={changeAllCampus}/>
                <ErrorMessage
                    error={errors.publicByCampusIds}
                    text="Es necesario seleccionar el/los Campus a los que pertenecen los estudiantes."/>
            </Column>
            {modalities !== undefined 
            && <Column gap="32px">
                <SubtitleSection>
                    Modalidad:
                </SubtitleSection>
                <HandlerRadio
                    value={modalityId}
                    onChange={changeModalityId}
                    radiosProps={
                        modalities.map(({
                            id, 
                            name 
                        }) => ({
                            value: id, 
                            label: name
                        }))
                    }
                    error={errors.modalityId}
                    errorText="Es necesario seleccionar la modalidad a la que pertenecen los estudiantes."/>
            </Column>}
        </>
    );
}

export default StudentsSection;